import { useContext, useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { IoIosCloseCircle } from "react-icons/io";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import Get from "../api/Get";
import { DOCTOR_NOTIFICACIONES, NOTIFICACIONE_PACIENTE } from "../api/Routes";
import ComponentModalErrorSever from "../components/ComponentModalErrorSever";
import { authContext } from "../context/AuthContext";
import LoadingList from "../loader/LoadingList";
import Notificaciones from "./doctor/perfil/Notificaciones";

function Trazabilidad({t,paciente}){
    const {id} = useParams()
    const [loading, setLoading] = useState(true);
    const {auth} = useContext(authContext)
    const [notificaciones, setNotificaciones] = useState([]) 
    const [showModalError, setShowModalError] = useState(false)
    const [errorServer, setErrorServer] = useState(null)
    const handleClose = () => setShowModalError(false)   

    useEffect(()=>{
        let url = paciente ? NOTIFICACIONE_PACIENTE : DOCTOR_NOTIFICACIONES
        Get({url: `${url}/${id}`, access_token: auth.data.access_token})
        .then(resp=>{
            setNotificaciones(resp.data.data.response)
            setLoading(false)            
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)  
        })
    },[])

    return(
        <>
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top">Trazabilidad</h2>
                </Col>
                <Col xs="12" md="4" className="text-right">
                    <Link to={paciente ? "/admin/patients" : "/admin/doctors"}><IoIosCloseCircle className="cancel-btn"/></Link>                    
                </Col>
            </Row>

            {loading ? <LoadingList texto="Cargando"/> :
            <Row className="mt-3">
                <Col>
                    <Card className="shadow-1">
                        {
                            notificaciones.length === 0 ?
                            <Card.Body>
                                <p>No existe información</p>
                            </Card.Body> :
                            <Card.Body>
                                <Notificaciones notificaciones={notificaciones} trazabilidad={true}/>
                            </Card.Body>
                        }
                    </Card>                    
                </Col>
            </Row>}
            <ComponentModalErrorSever 
                show={showModalError}
                handleClose={handleClose}
                error={errorServer}
            />
        </>
    )
}

export default withTranslation()(Trazabilidad)